
const usersDialog = {
  state: {
    usersState: false,
    usersArr: []  // [{id: '', label: ''}]
    // bmsIds: '',
    // bmsNames: ''
  },

  mutations: {
    SET_USERSSTATE: (state, val) => {
      state.usersState = val
    },
    SET_USERSARR: (state, val) => {
      state.usersArr = JSON.parse(JSON.stringify(val))
    }
  },

  actions: {
    
  }
}

export default usersDialog
